
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Magnetic from './Magnetic';

const Navbar: React.FC = () => {
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <motion.nav 
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed top-0 left-0 right-0 z-40 px-6 py-8 flex justify-between items-center bg-transparent backdrop-blur-sm md:backdrop-blur-none"
    >
      <Link to="/" className="text-xl font-display font-bold tracking-tighter interactive">
        DUOSTACK<span className="text-accent"> SYSTEMS</span>
      </Link>

      <div className="hidden md:flex space-x-8 items-center bg-zinc-900/50 border border-white/5 px-8 py-3 rounded-full backdrop-blur-xl">
        {navLinks.map((link) => (
          <Magnetic key={link.path} strength={0.3}>
            <Link 
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-accent ${
                location.pathname === link.path ? 'text-accent' : 'text-zinc-400'
              }`}
            >
              {link.name}
            </Link>
          </Magnetic>
        ))}
      </div>

      <div className="flex items-center space-x-4">
        <Magnetic strength={0.2}>
          <Link 
            to="/contact" 
            className="hidden md:block bg-white text-background px-6 py-2.5 rounded-full text-sm font-bold hover:bg-accent transition-colors interactive"
          >
            Work with us
          </Link>
        </Magnetic>
        {/* Mobile menu could be added here */}
      </div>
    </motion.nav>
  );
};

export default Navbar;
